<template>
  <div
    class="ai-computing-power-monitoring-chart-content"
    @mouseover="handleMouseover()"
    @mouseleave="handleMouseleave()"
  >
    <div class="instant-usage-hint-row">
      <span class="instant-usage-hint-label">瞬时使用率</span>
    </div>
    <div class="project-tabs">
      <!-- borderColor: activeProjectId === item.id ? '#20bef3' : 'black' -->
      <div
        class="project-tabs-item"
        v-for="(item, index) in projectList"
        :key="item.id"
        @click="changeActiveProjectId(item.id, index)"
        :style="{ color: activeProjectId === item.id ? '#20bef3' : '#adbece' }"
      >
        {{ item.name }}
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 6px;">
      <div
        class="project-group-tabs"
        v-if="
          projectList[activeProjectIndex] &&
          projectList[activeProjectIndex].childer &&
          projectList[activeProjectIndex].childer.length > 1
        "
      >
        <!-- borderColor: activeProjectId === item.id ? '#20bef3' : 'black' -->
        <div
          class="project-group-tabs-item"
          v-for="item in projectList[activeProjectIndex].childer"
          :key="item.id"
          @click="changeGroupId(item.id)"
          :style="{ color: activeGroupId === item.id ? '#20bef3' : '#adbece' }"
        >
          {{ item.name }}
        </div>
      </div>
      <div style="color:#adbece;font-size: 0.8rem;">瞬时使用率</div>
    </div>
    
    <div class="pie-chart-content">
      <div class="chert-item pie-chart-gpu" id="pie-chart-gpu"></div>
      <div class="chert-item pie-chart-cpu" id="pie-chart-cpu"></div>
      <div class="chert-item pie-chart-memory" id="pie-chart-memory"></div>
      <div class="chert-item pie-chart-storage" id="pie-chart-storage"></div>
    </div>
    <div class="bar-chart-top-title">
      <div class="title-left">算力使用率</div>
      <div class="title-right">
        <span class="usage-rate">近30天算力使用率 </span>
        <span class="usage-rate-num">{{
          computingPowerUtilizationRate + "%"
        }}</span>
      </div>
    </div>
    <div class="bar-chart-content">
      <div
        class="bar-chart-computing-power"
        id="bar-chart-computing-power"
      ></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { ajax } from "@/config/bi-request.js";
export default {
  name: "ai-computing-power-monitoring-chart",
  data() {
    return {
      interval: null,
      mouseIn: false,
      projectList: [],
      activeProjectId: "1",
      activeProjectIndex: 0,
      activeGroupId: "All",
      nextActiveProjectId: "",
      nextActiveGroupId: "All",
      nextActiveProjectIndex: 0,
      pieChartGPU: null,
      pieChartCPU: null,
      pieChartMemory: null,
      pieChartStorage: null,
      barChartComputingPower: null,
      pieChartGPUOptions: {
        title: {
          text: "GPU",
          left: "center",
          top: "bottom",
          textStyle: {
            fontSize: "0.8rem",
            color: "#bfcfe0",
          },
        },
        color: ["#8bccf3", "#2d496b"],
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 40, name: "完成值" },
              { value: 60, name: "目标值" },
            ],
          },
        ],
        // 绘制中间的百分比
        graphic: {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "40%",
            textAlign: "center",
            fill: "#fff",
            fontSize: "1rem",
          },
        },
      },
      pieChartCPUOptions: {
        title: {
          text: "CPU",
          left: "center",
          top: "bottom",
          textStyle: {
            fontSize: "0.8rem",
            color: "#bfcfe0",
          },
        },
        color: ["#8bccf3", "#2d496b"],
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 40, name: "完成值" },
              { value: 60, name: "目标值" },
            ],
          },
        ],
        // 绘制中间的百分比
        graphic: {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "40%",
            textAlign: "center",
            fill: "#fff",
            fontSize: "1rem",
          },
        },
      },
      pieChartMemoryOptions: {
        title: {
          text: "内存",
          left: "center",
          top: "bottom",
          textStyle: {
            fontSize: "0.8rem",
            color: "#bfcfe0",
          },
        },
        color: ["#8bccf3", "#2d496b"],
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 40, name: "完成值" },
              { value: 60, name: "目标值" },
            ],
          },
        ],
        // 绘制中间的百分比
        graphic: {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "40%",
            textAlign: "center",
            fill: "#fff",
            fontSize: "1rem",
          },
        },
      },
      pieChartStorageOptions: {
        title: {
          text: "存储",
          left: "center",
          top: "bottom",
          textStyle: {
            fontSize: "0.8rem",
            color: "#bfcfe0",
          },
        },
        color: ["#8bccf3", "#2d496b"],
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 40, name: "完成值" },
              { value: 60, name: "目标值" },
            ],
          },
        ],
        // 绘制中间的百分比
        graphic: {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "40%",
            textAlign: "center",
            fill: "#fff",
            fontSize: "1rem",
          },
        },
      },
      barChartComputingPowerOptions: {
        xAxis: {
          type: "category",
          data: [
            "03-01",
            "03-02",
            "03-03",
            "03-04",
            "03-05",
            "03-06",
            "03-07",
            "03-08",
            "03-09",
            "03-10",
            "03-11",
            "03-12",
            "03-13",
            "03-14",
            "03-15",
            "03-16",
            "03-17",
            "03-18",
            "03-19",
            "03-20",
            "03-21",
            "03-22",
            "03-23",
            "03-24",
            "03-25",
            "03-26",
            "03-27",
            "03-28",
            "03-29",
            "03-30",
          ],
          axisLabel: {
            color: "#9dadc0", // 设置字体颜色为
            fontSize: "0.6rem",
          },
          axisLine: {
            lineStyle: {
              color: "#293b52", // X轴线的颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          axisTick: {
            show: false, // 显示刻度线
            alignWithLabel: true, // 刻度线与标签对齐
            lineStyle: {
              color: "#293b52", // X轴刻度线的颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %",
            color: "#8992a1",
          },
          min: 0,
          splitNumber: 5,
          splitLine: {
            lineStyle: {
              color: "#293b52", // 设置分割线颜色
            },
          },
          // interval: 200,
        },
        grid: {
          left: 5,
          right: "4%",
          bottom: "26%",
          top: "6%",
          containLabel: true,
        },
        color: ["#4783af", "#3eb4a1", "#d6765b", "#314566"],
        legend: {
          textStyle: {
            color: "#9fb0c1", // 设置图例文字颜色
            fontSize: "0.8rem",
          },
          x: "center",
          y: "bottom",
          icon: "circle",
          itemHeight: 8,
          itemWidth: 8,
          data: ["正常", "空闲", "繁忙", "瞬时最高"],
          selectedMode: false,
        },
        series: [
          {
            barGap: "-100%",
            name: "瞬时最高",
            data: [
              90, 90, 90, 90, 100, 90, 90, 90, 90, 90, 90, 90, 90, 90, 100, 90,
              90, 90, 90, 90, 90, 90, 90, 90, 100, 90, 90, 90, 90, 90,
            ],
            type: "bar",
            barWidth: 8,
            itemStyle: {
              color: "#314566",
            },
          },
          {
            barCategoryGap: "100%",
            name: "正常",
            data: [
              20, 40, 60, 90, 50, 80, 20, 50, 20, 40, 20, 40, 60, 90, 50, 80,
              20, 50, 20, 40, 20, 40, 60, 90, 50, 80, 20, 50, 20, 40,
            ],
            type: "bar",
            barWidth: 8,
            itemStyle: {
              color: function (params) {
                if (
                  params.value <
                  (window._CONFIG.AIComputingPower.idleValue || 30)
                ) {
                  return "#3eb4a1";
                }
                if (
                  params.value <
                  (window._CONFIG.AIComputingPower.normalValue || 90)
                ) {
                  return "#4783af";
                }
                return "#d6765b";
              },
            },
          },
          {
            name: "空闲",
            data: [],
            type: "bar",
            itemStyle: {
              color: "#3eb4a1",
            },
          },
          {
            name: "繁忙",
            data: [],
            type: "bar",
            itemStyle: {
              color: "#d6765b",
            },
          },
        ],
      },
      computingPowerUtilizationRate: 0,
    };
  },
  mounted() {
    ajax.get("/getComputingPowerProject").then((res) => {
      this.projectList = res;
      // 默认第一个
      this.activeProjectId = res[0].id;
      this.nextActiveProjectId = res[0].id;
      this.pieChartGPU = echarts.init(document.getElementById("pie-chart-gpu"));
      // this.pieChartGPU.setOption(this.pieChartGPUOptions);
      this.pieChartCPU = echarts.init(document.getElementById("pie-chart-cpu"));
      // this.pieChartCPU.setOption(this.pieChartCPUOptions);
      this.pieChartMemory = echarts.init(
        document.getElementById("pie-chart-memory")
      );
      // this.pieChartMemory.setOption(this.pieChartMemoryOptions);
      this.pieChartStorage = echarts.init(
        document.getElementById("pie-chart-storage")
      );
      // this.pieChartStorage.setOption(this.pieChartStorageOptions);

      this.barChartComputingPower = echarts.init(
        document.getElementById("bar-chart-computing-power")
      );
      // this.barChartComputingPower.setOption(this.barChartComputingPowerOptions);
      this.upDateCharts();
    });

    this.interval = setInterval(() => {
      this.autoChange();
    }, 10000);
  },
  methods: {
    handleMouseover() {
      this.mouseIn = true;
    },
    handleMouseleave() {
      this.mouseIn = false;
    },
    autoChange() {
      if (this.mouseIn === false) {
        let i = this.projectList.findIndex((project) => {
          return project.id === this.activeProjectId;
        });
        if (i === this.projectList.length - 1) {
          i = 0;
        } else {
          i++;
        }
        this.nextActiveProjectId = this.projectList[i].id;
        this.nextActiveGroupId = "All";
        this.nextActiveProjectIndex = i;
        // this.activeProjectId = this.projectList[i].id;
        // this.activeGroupId = "All";
        // this.activeProjectIndex = i;
      }
      console.log("--------------222222222");
      this.upDateCharts(this.mouseIn);
    },
    changeActiveProjectId(id, index) {
      if (this.activeProjectId !== id) {
        this.nextActiveProjectId = id;
        this.nextActiveGroupId = "All";
        this.nextActiveProjectIndex = index;
        // this.activeProjectId = id;
        // this.activeGroupId = "All";
        // this.activeProjectIndex = index;
        console.log("--------------11111111111");
        this.upDateCharts();
      }
    },
    changeGroupId(id) {
      if (this.activeGroupId !== id) {
        this.nextActiveProjectId = this.activeProjectId;
        this.nextActiveGroupId = id;
        this.nextActiveProjectIndex = this.activeProjectIndex;
        // this.activeGroupId = id;
        console.log("--------------33333333");
        this.upDateCharts();
      }
    },
    // 获取数据更新界面
    upDateCharts(inDom = false) {
      if (inDom) {
        ajax
          .get("/getAIComputingPowerMonitoring", {
            projectId: this.nextActiveProjectId,
            groupId: this.nextActiveGroupId,
          })
          .then((chartData) => {
            this.pieChartGPUOptions.series[0].data[0].value = chartData.GPU;
            this.pieChartGPUOptions.series[0].data[1].value =
              100 - chartData.GPU;
            this.pieChartGPUOptions.graphic.style.text = chartData.GPU + "%";
            this.pieChartGPU.setOption(this.pieChartGPUOptions);
            this.pieChartCPUOptions.series[0].data[0].value = chartData.CPU;
            this.pieChartCPUOptions.series[0].data[1].value =
              100 - chartData.CPU;
            this.pieChartCPUOptions.graphic.style.text = chartData.CPU + "%";
            this.pieChartCPU.setOption(this.pieChartCPUOptions);
            this.pieChartMemoryOptions.series[0].data[0].value =
              chartData.memory;
            this.pieChartMemoryOptions.series[0].data[1].value =
              100 - chartData.memory;
            this.pieChartMemoryOptions.graphic.style.text =
              chartData.memory + "%";
            this.pieChartMemory.setOption(this.pieChartMemoryOptions);
            this.pieChartStorageOptions.series[0].data[0].value =
              chartData.storage;
            this.pieChartStorageOptions.series[0].data[1].value =
              100 - chartData.storage;
            this.pieChartStorageOptions.graphic.style.text =
              chartData.storage + "%";
            this.pieChartStorage.setOption(this.pieChartStorageOptions);
            this.activeProjectId = this.nextActiveProjectId;
            this.activeGroupId = this.nextActiveGroupId;
            this.activeProjectIndex = this.nextActiveProjectIndex;
          })
          .catch((err) => {});
        //   自动触发的时候鼠标在这里，不更新柱状图
        return;
      }

      Promise.all([
        ajax.get("/getAIComputingPowerMonitoring", {
          projectId: this.nextActiveProjectId,
          groupId: this.nextActiveGroupId,
        }),
        ajax.get("/getAIComputingPowerTrendChart", {
          projectId: this.nextActiveProjectId,
          groupId: this.nextActiveGroupId,
        }),
      ]).then((values) => {
        const chartData = values[0];
        this.pieChartGPUOptions.series[0].data[0].value = chartData.GPU;
        this.pieChartGPUOptions.series[0].data[1].value = 100 - chartData.GPU;
        this.pieChartGPUOptions.graphic.style.text = chartData.GPU + "%";
        this.pieChartGPU.setOption(this.pieChartGPUOptions);
        this.pieChartCPUOptions.series[0].data[0].value = chartData.CPU;
        this.pieChartCPUOptions.series[0].data[1].value = 100 - chartData.CPU;
        this.pieChartCPUOptions.graphic.style.text = chartData.CPU + "%";
        this.pieChartCPU.setOption(this.pieChartCPUOptions);
        this.pieChartMemoryOptions.series[0].data[0].value = chartData.memory;
        this.pieChartMemoryOptions.series[0].data[1].value =
          100 - chartData.memory;
        this.pieChartMemoryOptions.graphic.style.text = chartData.memory + "%";
        this.pieChartMemory.setOption(this.pieChartMemoryOptions);
        this.pieChartStorageOptions.series[0].data[0].value = chartData.storage;
        this.pieChartStorageOptions.series[0].data[1].value =
          100 - chartData.storage;
        this.pieChartStorageOptions.graphic.style.text =
          chartData.storage + "%";
        this.pieChartStorage.setOption(this.pieChartStorageOptions);

        this.activeProjectId = this.nextActiveProjectId;
        this.activeGroupId = this.nextActiveGroupId;
        this.activeProjectIndex = this.nextActiveProjectIndex;

        const barchartData = values[1];
        // 三十天的日期 例如03-01
        this.barChartComputingPowerOptions.xAxis.data = barchartData.dateList;
        // 算力瞬时最高三十个值 0-100
        this.barChartComputingPowerOptions.series[0].data =
          barchartData.InstantaneousHighest;
        // 算力三十个值 0-100
        this.barChartComputingPowerOptions.series[1].data =
          barchartData.computingPowerList;
        this.barChartComputingPower.setOption(
          this.barChartComputingPowerOptions
        );
        this.computingPowerUtilizationRate =
          barchartData.computingPowerUtilizationRate;
      });
      // ajax
      //   .get("/getAIComputingPowerTrendChart", {
      //     projectId: this.nextActiveProjectId,
      //     groupId: this.nextActiveGroupId,
      //   })
      //   .then((barchartData) => {
      //     this.activeProjectId = this.nextActiveProjectId;
      //     this.activeGroupId = this.nextActiveGroupId;
      //     this.activeProjectIndex = this.nextActiveProjectIndex;
      //     // 三十天的日期 例如03-01
      //     this.barChartComputingPowerOptions.xAxis.data = barchartData.dateList;
      //     // 算力瞬时最高三十个值 0-100
      //     this.barChartComputingPowerOptions.series[0].data =
      //       barchartData.InstantaneousHighest;
      //     // 算力三十个值 0-100
      //     this.barChartComputingPowerOptions.series[1].data =
      //       barchartData.computingPowerList;
      //     this.barChartComputingPower.setOption(
      //       this.barChartComputingPowerOptions
      //     );
      //     this.computingPowerUtilizationRate =
      //       barchartData.computingPowerUtilizationRate;
      //   })
      //   .catch((err) => {});
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="less" scoped>
.ai-computing-power-monitoring-chart-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .instant-usage-hint-row {
    flex-shrink: 0;
    text-align: right;
    padding: 0 6% 0.2rem;
    box-sizing: border-box;
  }
  .instant-usage-hint-label {
    color: #adbece;
    font-size: 0.8rem;
    font-weight: 600;
  }
  .project-tabs {
    display: flex;
    overflow: hidden;
    height: 1.2rem;
    padding-left: 6%;
    flex-shrink: 0;
    .project-tabs-item {
      box-sizing: border-box;
      font-size: 0.8rem;
      font-weight: 600;
      height: 1.2rem;
      line-height: 1.2rem;
      cursor: pointer;
      border-bottom: 0.1rem solid;
      margin-right: 1.5rem;
    }
  }
  .project-group-tabs {
    margin-top: 2%;
    display: flex;
    overflow: hidden;
    padding-left: 6%;
    flex-shrink: 0;
    .project-group-tabs-item {
      font-size: 0.8rem;
      font-weight: 600;
      height: 1.2rem;
      line-height: 1.2rem;
      cursor: pointer;
      border-bottom: 0.1rem solid;
      margin-right: 1.5rem;
    }
  }
  .pie-chart-content {
    flex-shrink: 0;
    height: 34%;
    display: flex;
    padding: 0 4%;
    .chert-item {
      width: 24%;
    }
  }
  .bar-chart-top-title {
    display: flex;
    height: 1.2rem;
    justify-content: space-between;
    align-items: center;
    padding: 2% 2% 0 2%;
    .title-left {
      color: #a9bacb;
      font-size: 1rem;
    }
    .title-right {
      color: #a9bacb;
      font-size: 0.8rem;
      .usage-rate-num {
        color: #4cb0dc;
      }
    }
  }
  .bar-chart-content {
    flex: 1 0;
    // overflow: hidden;
    .bar-chart-computing-power {
      width: 100%;
      height: 100%;
    }
  }
}
</style>